import { Component, Event, EventEmitter, JSX, Prop, h } from '@stencil/core'
import { BusinessClass } from '../air-business-class/air-business-class.types'

@Component({
  tag: 'air-business-class-card',
  styleUrl: 'air-business-class-card.scss',
  shadow: true,
})
export class AirBusinessClassCard {
  /** BusinessClass object */
  @Prop() businessClass!: BusinessClass

  /** Triggers when the current card is clicked */
  @Event({ eventName: 'air-select' }) select?: EventEmitter<BusinessClass>

  private handleSelect = (event: MouseEvent): void => {
    event.stopPropagation()
    this.select?.emit(this.businessClass)
  }

  render(): JSX.Element {
    return (
      <div tabindex="0" class="cob-card" onClick={this.handleSelect}>
        {this.businessClass.title && <span class="cob-title">{this.businessClass.title}</span>}
        {this.businessClass.ancestorTitles && (
          <span class="cob-title-secondary">{this.businessClass.ancestorTitles}</span>
        )}
        <span class="cob-code">NAICS code: {this.businessClass.code.split('-')[0]}</span>
        <slot />
      </div>
    )
  }
}
